import {
  AcademicCapIcon,
  BellIcon,
  CalendarIcon,
  CameraIcon,
  ChatBubbleLeftRightIcon,
  CreditCardIcon,
  EnvelopeIcon,
  GiftIcon,
  HandThumbUpIcon,
  HeartIcon,
  MapPinIcon,
  MegaphoneIcon,
  ShoppingBagIcon,
  SparklesIcon,
  StarIcon,
  TicketIcon,
  TrophyIcon,
  UserIcon,
  WalletIcon
} from '@heroicons/vue/24/outline'

export const MISSION_HEROICONS = {
  UserIcon,
  HeartIcon,
  MegaphoneIcon,
  GiftIcon,
  WalletIcon,
  CreditCardIcon,
  SparklesIcon,
  StarIcon,
  TrophyIcon,
  TicketIcon,
  ShoppingBagIcon,
  CalendarIcon,
  MapPinIcon,
  CameraIcon,
  ChatBubbleLeftRightIcon,
  EnvelopeIcon,
  BellIcon,
  HandThumbUpIcon,
  AcademicCapIcon
}
